import './landing-banner.scss';
export default async () => {
    const element = document.getElementById("cta-subject");
    if (!element) {
        return;
    }
    element.addEventListener("change", function() {
        let customInput = document.getElementById("customTopicInput");

        if (this.value === "custom") {
            customInput.style.display = "block";
        } else {
            customInput.style.display = "none";
        }

    });

};
